import { render, staticRenderFns } from "./SnsJoinComplete.vue?vue&type=template&id=1ede35eb&"
import script from "./SnsJoinComplete.vue?vue&type=script&lang=ts&"
export * from "./SnsJoinComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports